import * as React from 'react';
import cx from 'classnames';

import * as cs from './Stack.module.css';

interface Props {
  as?: 'div' | 'section';
  children: React.ReactNode;
  direction: 'vertical' | 'horizontal';
  gap: number;
}

export const Stack = ({
  as: ComponentToRender = 'div',
  children,
  direction,
  gap,
}: Props) => (
  <ComponentToRender
    style={{ '--gap': gap } as React.CSSProperties}
    className={cx(cs.root, cs[`direction_${direction}`])}
  >
    {children}
  </ComponentToRender>
);
